import { useReports } from "@sail/observability";
import { once } from "@sail/utils";
import { useContext } from "react";
import DataConfigContext from "../internal/config/DataConfigContext";
import defaultConfig from "../internal/config/defaultConfig";
class DataConfigError extends Error {
    constructor(message){
        super(`[@sail/data] ${message}`);
    }
}
const reportUninitializedErrorOnce = once((report)=>{
    const error = new DataConfigError('Make sure to provide the required config for data to DataProvider upon initialization.');
    report(error, {
        tags: {
            namespace: 'data'
        }
    });
});
export default function useDataConfig() {
    const config = useContext(DataConfigContext);
    const { error } = useReports();
    if (config === defaultConfig) {
        reportUninitializedErrorOnce(error);
    }
    return config;
}

//# sourceMappingURL=useDataConfig.js.map